import { mapState } from 'pinia';
import stores from 'store/modules';

export default {
    computed: {
        isAssuming() {
            return sessionStorage.getItem('assume_token');
        },

        checkRequestInboxAccess() {
            return this.user.role !== 'owner' && Object.keys(this.inboxes).length === 0;
        },

        ...mapState(stores.User, ['user', 'userSettings', 'isDeveloper']),
        ...mapState(stores.Inboxes, ['inboxes']),
    },

    methods: {
        clearDisconnectNotification(redirect = false) {
            this.$store.dispatch('removeIntegrationDisconnected').then(() => {
                if (redirect) {
                    this.$router.push('/settings/integrations');
                }
            });
        },

        initRetently() {
            try {
                (function (d, s, id) {
                    var js,
                        rjs = d.getElementsByTagName(s)[0];
                    if (d.getElementById(id)) return;
                    js = d.createElement(s);
                    js.id = id;
                    js.src = 'https://cdn.retently.com/public/components/embed/sdk.min.js';
                    rjs.parentNode.insertBefore(js, rjs);
                })(document, 'script', 'retently-jssdk');
            } catch (e) {
                this.$log.error(e, this.$options.__file, 'initRetently');
            }
        },

        handleChangeRoleRequestClosed() {
            this.$store.dispatch('changeModalChangeRoleRequest', {
                status: false,
                customText: null,
            });
        },

        handleChangeRoleRequestOpen(customText) {
            this.$store.dispatch('changeModalChangeRoleRequest', { status: true, customText });
        },

        async doLogout() {
            try {
                await this.$store.dispatch('updateAuthLogout');

                this.$store.dispatch('loggingOut');
                this.$cookie.set('salesmessage-user-logout', '1D');
                this.$cookie.remove('salesmessage-token');
                this.$cookie.remove('not_show_short_url_banner');
                localStorage.removeItem('token');

            } catch (e) {
                this.$log.error(e, this.$options.__file, 'logout');
            } finally {
                window.location = '/';
            }
        },
    },
};
